import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from './service';
import {Subject} from 'rxjs';
import { ToastService } from '../../../toast.service';

@Component({
  selector: 'app-sub-modules',
  templateUrl: './sub-modules.component.html',
  styleUrls: ['./sub-modules.component.css']
})
export class SubModulesComponent implements OnInit {

  addflag: any = 0;

  show = false;
  fullScreen = true;
  template = ``;

  user_role: any;
  validmsg: any;
  resstatus = localStorage.getItem('resstatus');
  type_name = localStorage.getItem('type_name');
  mastermodule_name = localStorage.getItem('mastermodule_name');

  public AddInfo:FormGroup;
  AddInfoSubmitted: boolean = false;

  public EditInfo:FormGroup;
  EditInfoSubmitted: boolean = false;

  public DeleteInfo:FormGroup;
  
  InfoArray: any = [];    
  InfoArray_country: any = [];
  InfoArray_state: any = [];
  InfoArray_city: any = [];

  displayStyle_add = "none";
  displayStyle_edit = "none";
  displayStyleDelete = "none";
  displayStyleActivate = "none";
  displayStyleDeactivate = "none";

  dtOptions: DataTables.Settings = {
    destroy: true,
    scrollX: true,
    columnDefs: [
      { orderable: true, className: 'reorder', targets: 0 },
      { orderable: false, targets: '_all' }
    ]
  };
  dtTrigger: Subject<any> = new Subject<any>();    

  constructor(private fb: FormBuilder, private dataservice: Service, private route: Router, private toastService: ToastService) {
    this.route.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.user_role = localStorage.getItem('type_name');
      }
      if (this.resstatus == null) {
        this.route.navigate(['/home']);
      }
    });
   }

  ngOnInit(): void {

    this.initGroup();
    setTimeout(() => {
      $('.dataTables_wrapper .dataTables_filter input').attr('placeholder', 'Search...');
    }, 1000);
  }

  initGroup(){

    this.InfoArray = [];
    this.getInfo();
    // this.getCountry();   

    this.validmsg = '';
    $('#validmsg').css('display', 'none');

    // Form element defined below
    this.AddInfo = this.fb.group({
      module_name: new FormControl('', Validators.required),
      module_url: new FormControl('', Validators.required),
      module_content: new FormControl('', Validators.required),
    });

    // Form element defined below
    this.EditInfo = this.fb.group({
      module_name_edit: new FormControl('', Validators.required),
      module_url_edit: new FormControl('', Validators.required),
      module_content_edit: new FormControl('', Validators.required),

      edit_id: new FormControl(''),
      edit_is_active: new FormControl(''),
    });

    // Form element defined below
    this.DeleteInfo = this.fb.group({
      delete_id: new FormControl('')      
    });

  }  

  //Add
  get getAddInformationFormControls() {
    return this.AddInfo.controls;
  }

  openPopupAdd(){
    this.addflag = 1;
    // this.EditInfo.controls['module_url'].setValue('');
    // this.EditInfo.controls['module_name'].setValue('');
    // this.displayStyle_add = "block";
  }  

  closePopupAdd(){
    this.addflag = 0;      
    window.location.reload();    
  }

  onSubmitAdd() {

    this.AddInfoSubmitted = true;
    if (this.AddInfoSubmitted && this.AddInfo.valid) {
      
      this.show = true;
      this.fullScreen = true;
      this.template = ``;
      
      var postdata = {
        "tokenable_id":localStorage.getItem('tokenable_id'),        
        "parent_id":localStorage.getItem('mastermodule_id'),

        "module_name":this.AddInfo.controls['module_name'].value,
        "module_url":this.AddInfo.controls['module_url'].value,
        "module_content":this.AddInfo.controls['module_content'].value,                       
      };
      // console.log(postdata);

      this.show = false;

      this.dataservice.AddInfo(postdata)
        .subscribe((result: any) => {
          
          // console.log(result);                    

          if (result.status == true) {  
            
            this.show = false;
            this.toastService.showSuccess('Success', 'Details Added Successfully!');        

            setTimeout(() => {
              window.location.reload();
            },3000);

            this.getInfo();
            this.dtTrigger.unsubscribe();
          }else {            
            this.show = false;         
          }
        }, (error) => {          

          if(error.error.message == 'Unauthenticated.'){
            localStorage.clear();
            localStorage.setItem('resstatus', 'false');
            this.route.navigate(['/login']);
          }
          
          this.toastService.showFailed('Failed', 'There was some error !');               
      });
      
    } else {
      // validate all form fields
    }
  }

  //Edit
  get getEditInformationFormControls() {
    return this.EditInfo.controls;
  }

  openPopupEdit(res: any){          

    // this.displayStyle_edit = "block";

    this.addflag = 2;

    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "id":res.id,
      "parent_id":localStorage.getItem('mastermodule_id'),
    };

    this.dataservice.InfoSingle(postdata)
      .subscribe((result: any) => {
        
        // console.log(result[0]['username']);

        this.EditInfo.controls['module_name_edit'].setValue(result.data[0]['module_name']);
        this.EditInfo.controls['module_url_edit'].setValue(result.data[0]['module_url']);        
        this.EditInfo.controls['module_content_edit'].setValue(result.data[0]['module_content']);
        
        this.EditInfo.controls['edit_id'].setValue(result.data[0]['id']);                      

      }, (error) => {          
               
    });

  }

  onSubmitEdit(){

    let id = $('#edit_id').val();
   
    this.EditInfoSubmitted = true;
    if (this.EditInfoSubmitted && this.EditInfo.valid) {

      this.show = true;
      this.fullScreen = true;
      this.template = ``;
      
      var postdata = {
        "tokenable_id":localStorage.getItem('tokenable_id'),
        "id": id,
        "parent_id":localStorage.getItem('mastermodule_id'),
        
        "module_name":this.EditInfo.controls['module_name_edit'].value,                
        "module_url":this.EditInfo.controls['module_url_edit'].value,        
        "module_content":this.EditInfo.controls['module_content_edit'].value,        
      };

      this.show = false;

      this.dataservice.InfoUpdate(postdata)
        .subscribe((result: any) => {
          
          if (result.status == true) {            
            
            this.show = false;
            this.closePopup();         
            this.toastService.showSuccess('Success', 'Details Updated Successfully!');        

            setTimeout(() => {
              window.location.reload();
            },3000);

          }else {
              this.show = false;
          }
        }, (error) => {          
          this.closePopup();         
          this.toastService.showFailed('Failed', 'There was some error !');               
      });

    }

  }

  //Delete
  openPopupDelete(res: any) {
    this.displayStyleDelete = "block";  
    
    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "id":res.id,
      "parent_id":localStorage.getItem('mastermodule_id'),
    };

    this.dataservice.InfoSingle(postdata)
      .subscribe((result: any) => {
        
        // console.log(result);
        this.DeleteInfo.controls['delete_id'].setValue(result.data[0]['id']);
        
      }, (error) => {          
               
    });

  }

  onSubmitDelete(){

    let id = $('#delete_id').val();

    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "id": id,
      "parent_id":localStorage.getItem('mastermodule_id'),
    };

    this.dataservice.InfoDelete(postdata)
      .subscribe((result: any) => {
        
        if (result.status == true) {            
          
          this.show = false;
          this.toastService.showSuccess('Success', 'Details Deleted Successfully!');       
          this.closePopup();       
          this.getInfo();
          this.dtTrigger.unsubscribe();

        } else {
          // console.log(result);            
        }
      }, (error) => {    
        this.closePopup();
        this.toastService.showFailed('Failed', 'There was some error !');        
       
    });

  }

  //Common functions
  getInfo(){

    this.show = true;
    this.fullScreen = true;
    this.template = ``; 

    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "parent_id":localStorage.getItem('mastermodule_id'),
    }

    this.dataservice.getInfo(postdata)
        .subscribe((result: any) => {          
          
          this.show = false;
          // console.log(result);
          this.InfoArray = result.data; 
          this.dtTrigger.next();

        }, (error) => {          
          
          this.InfoArray = [];
          
      });
  }

  getCountry(){

    this.show = true;
    this.fullScreen = true;
    this.template = ``; 

    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),      
    };

    this.dataservice.getCountry(postdata)
        .subscribe((result: any) => {          
          
          this.show = false;
          // console.log(result);
          this.InfoArray_country = result.data;           

        }, (error) => {          
          
          this.InfoArray_country = [];
          
      });
  }  

  getState(evt: any){

    let val = evt.target.value;

    this.show = true;
    this.fullScreen = true;
    this.template = ``; 

    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "country_id":val,      
    };

    this.dataservice.getInfoState(postdata)
        .subscribe((result: any) => {          
          
          this.show = false;
          // console.log(result);
          this.InfoArray_state = result.data;           

        }, (error) => {          
          
          this.InfoArray_state = [];
          
      });
  }

  getCity(evt: any){

    let val = evt.target.value;

    this.show = true;
    this.fullScreen = true;
    this.template = ``; 

    var postdata = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "state_id":val,      
    };

    this.dataservice.getInfoCity(postdata)
        .subscribe((result: any) => {          
          
          this.show = false;
          // console.log(result);
          this.InfoArray_city = result.data;           

        }, (error) => {          
          
          this.InfoArray_city = [];
          
      });
  }

  closealert(){
    $("#validmsg").css('display', 'none');
    $("#errormsg").css('display', 'none');
  }

  closePopup() {    

    this.displayStyle_add = "none";
    this.displayStyle_edit = "none";
    this.displayStyleDelete = "none";  
    this.displayStyleDeactivate = "none";  
    this.displayStyleActivate = "none";  
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  isNumber(evt: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }                 
    return true;
  }

  isDecimal(evt: any){
    var content = evt.target.value;
    var ipaddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;          
    if (ipaddress.test(content) == false) {       
      $("#ip_address").val('');
    } else {
      $("#ip_address").val(content);
    }
  }
  
  isDecimal_edit(evt: any){
    var content = evt.target.value;
    var ipaddress = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;          
    if (ipaddress.test(content) == false) {       
      $("#ip_address_edit").val('');
    } else {
      $("#ip_address_edit").val(content);
    }
  }

  viewuser(res: any){
    
    localStorage.setItem('brokerView_id', res.id);
    this.route.navigate(['admin-mastermodules/sub-modules']);
        
  }  

  backtomaster(){
    this.route.navigate(['admin-mastermodules']);
  }

    // Deactive Active //
    subModuleId:any;
    openPopupDeactivate(id: any) {
      this.displayStyleDeactivate = "block";  
      this.subModuleId = id;
    }
  
    onSubmitDeactivate(){
  
      this.show = true;
      this.fullScreen = true;
      this.template = ``;
  
      var postdata = {
        "tokenable_id":localStorage.getItem('tokenable_id'),
        "parent_id":localStorage.getItem('mastermodule_id'),
        "id": this.subModuleId,
        "is_active": 0
      };
  
      this.dataservice.InfoActiveDeactivate(postdata)
        .subscribe((result: any) => {
          
          if (result.status == true) {            
            
            this.show = false;
            this.toastService.showSuccess('Success', 'Details Deactivated Successfully!');  
            
            setTimeout(() => {
              window.location.reload();
            },3000);
  
            this.closePopup();       
            this.getInfo();
            this.dtTrigger.unsubscribe();
  
          } else {
            // console.log(result);            
          }
        }, (error) => {  
          this.show = false;  
          this.closePopup();
          this.toastService.showFailed('Failed', 'There was some error !');                     
      });
  
    }
  
    openPopupActivate(id: any) {
      this.displayStyleActivate = "block";  
      this.subModuleId = id;
    }
  
    onSubmitActivate(){
  
      this.show = true;
      this.fullScreen = true;
      this.template = ``;
  
      var postdata = {
        "tokenable_id":localStorage.getItem('tokenable_id'),
        "parent_id":localStorage.getItem('mastermodule_id'),
        "id": this.subModuleId,
        "is_active": 1
      };
  
      this.dataservice.InfoActiveDeactivate(postdata)
        .subscribe((result: any) => {
          
          if (result.status == true) {            
            
            this.show = false;
            // console.log(result.data);          
  
            this.toastService.showSuccess('Success', 'Details Activated Successfully!'); 
            
            setTimeout(() => {
              window.location.reload();
            },3000);
  
            this.closePopup();       
            this.getInfo();
            this.dtTrigger.unsubscribe();
  
          } else {
            // console.log(result);            
          }
        }, (error) => {  
          this.show = false;  
          this.closePopup();
          this.toastService.showFailed('Failed', 'There was some error !');             
      });
  
    }

}

